// TODO: fix icon only button styling
// TODO: fix end and start icon styling

import { forwardRef, isValidElement } from 'react';
import { Button as MuiButton } from '@mui/material';
import { buttonMuiVariantMap, buttonMuiSizeMap } from './buttonMuiMap';
import { buttonStyleBuilder } from './buttonStyleBuilder';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { LoadingButtonOverlay } from './LoadingButtonOverlay';
import { withLinkComponent } from './withLinkComponent';

/**
 * Highlighted actions to select
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Button = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    block,
    buttonStyle,
    children,
    className,
    disabled,
    href,
    icon = undefined,
    startIcon,
    endIcon,
    onClick,
    onMouseOver,
    onMouseOut,
    onMouseDown,
    onMouseDownCapture,
    onMouseOverCapture,
    onMouseOutCapture,
    onFocusCapture,
    onBlurCapture,
    type,
    size,
    id,
    sx,
    autoFocus,
    tabIndex,
    isLoading = false,
    rel,
    target
  } = props;
  const theme = useInterstateTheme();
  const style = mergeSxStyle(buttonStyleBuilder(buttonStyle, size, disabled, Boolean(icon), theme, Boolean(isLoading)), sx);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(MuiButton, {
      sx: style,
      fullWidth: block,
      variant: buttonMuiVariantMap(buttonStyle),
      type: type,
      onClick: onClick,
      className: className,
      href: href,
      LinkComponent: withLinkComponent(target, rel),
      disableFocusRipple: true,
      disableElevation: true,
      disableRipple: true,
      endIcon: /*#__PURE__*/isValidElement(icon) ? undefined : endIcon,
      startIcon: /*#__PURE__*/isValidElement(icon) ? undefined : startIcon,
      size: buttonMuiSizeMap(size),
      id: id,
      disabled: disabled,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      onMouseDown: onMouseDown,
      onMouseDownCapture: onMouseDownCapture,
      onMouseOverCapture: onMouseOverCapture,
      onMouseOutCapture: onMouseOutCapture,
      onBlurCapture: onBlurCapture,
      onFocusCapture: onFocusCapture,
      ref: ref,
      autoFocus: autoFocus,
      "data-testid": props['data-testid'],
      tabIndex: tabIndex,
      children: [icon || children, isLoading && (buttonStyle === 'primary' || buttonStyle === 'secondary') && /*#__PURE__*/_jsx(LoadingButtonOverlay, {
        ...props
      })]
    })
  });
});
Button.displayName = 'Button';

/*
 : null}

 */